import { useSyncExternalStore } from "react";

/** Tailwind's `lg` — the width the desktop shell switches on. */
const DESKTOP_QUERY = "(min-width: 1024px)";

/**
 * For the cases a `lg:` class can't cover — picking different data, or a
 * different component, rather than different styling. Reads the real value on
 * the first render, so nothing flashes the wrong layout.
 */
export function useIsDesktop() {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(DESKTOP_QUERY);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(DESKTOP_QUERY).matches,
    () => false,
  );
}
